/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { SimulateAllTypes, SimulateState } from './types';

const INITIAL_STATE: SimulateState = {
  simulate: {
    original: {
      invoice: {},
      card: {},
    },
    package_name: '',
    plan_id: '',
    renewal: false,
  },
  assinaturaDigital: {
    assinatura_digital: false,
  },
  servicoAdicional: {
    servico_adicional: false,
  },
  requestSimulate: {
    loading: false,
    loaded: false,
    error: false,
  },
};
const reducer: Reducer<SimulateState> = (
  state = INITIAL_STATE,
  { type, result, status, status_service },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case SimulateAllTypes.GET_SIMULATE_REQUEST:
        draft.requestSimulate = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case SimulateAllTypes.GET_SIMULATE_SUCCESS:
        const { package_name, plan_id, renewal } = result.data;
        draft.simulate.original = result.data.packages;
        draft.simulate.package_name = package_name;
        draft.simulate.plan_id = plan_id;
        draft.simulate.renewal = renewal;
        draft.requestSimulate = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case SimulateAllTypes.GET_SIMULATE_FAILURE:
        draft.requestSimulate = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case SimulateAllTypes.UPDATE_STATE_ASSINATURA_DIGITAL:
        draft.assinaturaDigital = {
          assinatura_digital: status,
        };
        break;
      case SimulateAllTypes.UPDATE_STATE_SERVICO_ADICIONAL:
        draft.servicoAdicional = {
          servico_adicional: status_service,
        };
        break;
      default:
    }
  });
};
export default reducer;
